/**
 * Techniker-Home
 * PR-5B: TechLayout Integration
 */

import { Link } from 'react-router-dom';
import { useAuth } from '../../App';
import { TechLayout } from '../../components/TechLayout';
import { ModuleBadge } from '../../components/ModuleBadge';
import {
  AlertTriangle,
  ChevronRight,
} from 'lucide-react';

export default function TechHomePage() {
  const { user } = useAuth();

  // RBAC wird von TechLayout gehandhabt

  return (
    <TechLayout>
      <div className="space-y-6">
        {/* Willkommen */}
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Willkommen</h1>
          <p className="text-sm text-slate-500 mt-1">{user?.displayName}</p>
        </div>

        {/* Module Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Störungen */}
          <Link
            to="/tech/disruptions"
            className="bg-white rounded-lg border border-orange-200 hover:border-orange-400 hover:shadow-lg transition-all p-6"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="p-3 bg-orange-100 rounded-lg">
                  <AlertTriangle className="w-6 h-6 text-orange-600" />
                </div>
                <div>
                  <div className="font-semibold text-slate-900 flex items-center gap-2">
                    Störungen
                    <ModuleBadge module="disruptions" />
                  </div>
                  <p className="text-sm text-slate-500">Störungen bearbeiten</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-400" />
            </div>
          </Link>
        </div>
      </div>
    </TechLayout>
  );
}
